import React, { useEffect, useState } from "react";
import { fetchAuditLog, getCurrency } from "../services/api";
import { formatPrice } from "../utils/currency";
import { useT } from "../i18n/useT";

// Owner/manager activity log (SEC-2): who did what — discounts, tab reopens,
// order cancellations — for loss prevention and oversight. Read-only, over the
// existing immutable audit log.
const S = {
  en: { title: "Activity log", subtitle: "Sensitive actions across your property — for oversight and loss prevention.",
        all: "All actions", discount: "Discounts", reopen: "Tab reopens", cancel_order: "Order cancellations",
        none: "No activity recorded yet.", who: "Who", action: "Action", detail: "Detail", amount: "Amount", when: "When", approved: "Approved by" },
  am: { title: "የእንቅስቃሴ መዝገብ", subtitle: "በንብረትዎ ውስጥ ያሉ ስሱ ድርጊቶች — ለቁጥጥርና ኪሳራ መከላከል።",
        all: "ሁሉም ድርጊቶች", discount: "ቅናሾች", reopen: "ታብ እንደገና መክፈት", cancel_order: "ትዕዛዝ መሰረዝ",
        none: "እስካሁን የተመዘገበ እንቅስቃሴ የለም።", who: "ማን", action: "ድርጊት", detail: "ዝርዝር", amount: "መጠን", when: "መቼ", approved: "ያፀደቀው" },
  om: { title: "Galmee sochii", subtitle: "Gochaalee hubannoo qaban qabeenya kee keessaa — to'annoo fi hir'ina ittisuuf.",
        all: "Gochaalee hunda", discount: "Hir'isa", reopen: "Taab deebisanii banuu", cancel_order: "Ajaja haquu",
        none: "Ammatti sochiin hin galmoofne.", who: "Eenyu", action: "Gocha", detail: "Bal'ina", amount: "Hanga", when: "Yoom", approved: "Kan mirkaneesse" },
};
const CARD = { background: "#fff", border: "1px solid #eef2f2", borderRadius: 14, boxShadow: "0 1px 3px rgba(6,59,72,0.06)" };
const ACT_COLOR = { discount: "#854F0B", reopen: "#0C447C", cancel_order: "#A32D2D" };

export default function ActivityPage() {
  const { lang } = useT();
  const t = (k) => (S[lang] && S[lang][k]) || S.en[k] || k;
  const cur = getCurrency() || "ETB";
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => { fetchAuditLog(filter ? { action: filter } : {}).then(setRows).catch(() => setRows([])); }, [filter]);
  const th = { textAlign: "left", padding: "8px 10px", fontSize: 12, color: "#5b6472", borderBottom: "1px solid #eef2f2", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", fontSize: 13, borderBottom: "1px solid #f3f6f6", verticalAlign: "top" };

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto" }}>
      <h1 style={{ marginBottom: 2 }}>{t("title")}</h1>
      <div className="muted" style={{ fontSize: 14 }}>{t("subtitle")}</div>
      <div style={{ display: "flex", gap: 6, margin: "14px 0", flexWrap: "wrap" }}>
        {[["", "all"], ["discount", "discount"], ["reopen", "reopen"], ["cancel_order", "cancel_order"]].map(([v, k]) => (
          <button key={k} onClick={() => setFilter(v)} className={"btn small " + (filter === v ? "primary" : "secondary")}>{t(k)}</button>
        ))}
      </div>
      {rows == null ? <p className="muted">…</p> : rows.length === 0 ? (
        <div style={{ ...CARD, padding: 20, textAlign: "center" }} className="muted">{t("none")}</div>
      ) : (
        <div style={{ ...CARD, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>
              <th style={th}>{t("when")}</th><th style={th}>{t("who")}</th><th style={th}>{t("action")}</th>
              <th style={th}>{t("detail")}</th><th style={{ ...th, textAlign: "right" }}>{t("amount")}</th><th style={th}>{t("approved")}</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td style={td}>{r.created_at ? new Date(r.created_at).toLocaleString() : ""}</td>
                  <td style={td}>{r.actor_name || "—"}{r.actor_role ? <span className="muted"> · {r.actor_role}</span> : null}</td>
                  <td style={{ ...td, fontWeight: 600, color: ACT_COLOR[r.action] || "#334155" }}>{t(r.action) || r.action}</td>
                  <td style={td}>{r.detail || r.reason || "—"}</td>
                  <td style={{ ...td, textAlign: "right" }}>{r.amount != null ? formatPrice(r.amount, cur) : "—"}</td>
                  <td style={td}>{r.approved_by_name || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
